import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import moment from 'moment';
import '@/plugins/dynamicTime';
import {App as CapacitorApp} from '@capacitor/app';
import {useSettings} from './store/settings';
import {NativeAudio} from '@capgo/native-audio';
import * as api from './api';
import storeTheNames from '@/plugins/piniaStoreById';
import {createApp} from 'vue';
import 'vuetify/styles';
import {vuetify} from './plugins/vuetify';
import pinia from './plugins/pinia';
// import {fetchOrders} from './api';
pinia.use(storeTheNames);

/**
 * Hardware zurück Button deaktivieren
*/
CapacitorApp.addListener('backButton', ({canGoBack}) => {
  if (!canGoBack) {
    // App Beenden (?)
    // CapacitorApp.exitApp();
    router.replace('/').catch(console.error);
  } else {
    // History back
    if (router.currentRoute.value.meta?.canGoBack) return router.back();
    router.push('/').catch(console.error);
  }
});


async function init() {
  moment.locale('de-DE');
  const settingsStore = useSettings(pinia);
  await settingsStore.init();
  api.init();
  const app = createApp(App);
  app.use(pinia);
  app.use(router);
  app.use(vuetify);

  router.isReady().then(()=>{
    app.mount('#app');
  });

  console.log('Vue initialized');

  // Sounds laden
  NativeAudio.preload({
    assetId: 'action-negative',
    assetPath: 'assets/sounds/piep-zweimal-Tief.mp3',
    audioChannelNum: 1,
    isUrl: false,
  });
  NativeAudio.preload({
    assetId: 'action-positive',
    assetPath: 'assets/sounds/piep-einmal-B.mp3',
    audioChannelNum: 1,
    isUrl: false,
  });
  NativeAudio.preload({
    assetId: 'nve-positive',
    assetPath: 'assets/sounds/nve_sound.mp3',
    audioChannelNum: 1,
    isUrl: false,
  });
}

init();
